<script setup lang="ts">
    import { inject } from 'vue';
    import { injectorAccessInjectionKey } from '@cwd/lib/provider-keys';
    import { DashboardAccess } from '@views/Dashboard/Dashboard.access';
    import Loading from '@shared/components/Loading.vue';
    import BsAlert from '@shared/components/BsAlert.vue';
    import { AlertTypes } from '@shared/components/BsAlerts';
    import DashboardScheduledItem from './DashboardScheduledItem.vue';
    import DashboardRecentItem from './DashboardRecentItem.vue';

    const injectorAccess = inject(injectorAccessInjectionKey)!;
    const dashboardAccess: DashboardAccess = injectorAccess.injector.get(DashboardAccess);
</script>

<template>
    <section>
        <h2 class="h4 m-0-t strong">{{ $Resources.DashboardTimelineHeading }}</h2>
        <h3 class="text-xs text-uppercase h-divider">{{ $Resources.DashboardScheduledItemsHeading }}</h3>

        <BsAlert
            v-if="!dashboardAccess.state.scheduledItems.length && !dashboardAccess.state.loadingScheduledItems"
            :type="AlertTypes.Info"
            :content="$Resources.NoScheduledActivitiesMessage"
            :dismissible="false" />

        <div v-if="dashboardAccess.state.scheduledItems.length">
            <ul class="list-1 list-unstyled">
                <li v-for="item in dashboardAccess.state.scheduledItems" :key="item.Url">
                    <DashboardScheduledItem :item="item" />
                </li>
            </ul>
        </div>

        <Loading :show="dashboardAccess.state.loadingScheduledItems" loadingStyle="progress-bar" />

        <h3 class="text-xs text-uppercase h-divider">{{ $Resources.DashboardRecentItemsHeading }}</h3>

        <BsAlert
            v-if="!dashboardAccess.state.recentItems.length && !dashboardAccess.state.loadingRecentItems"
            :type="AlertTypes.Info"
            :content="$Resources.NoCompletedActivitiesMessage"
            :dismissible="false" />

        <div v-if="dashboardAccess.state.recentItems.length">
            <ul class="list-1 list-unstyled">
                <li v-for="item in dashboardAccess.state.recentItems" :key="item.Url">
                    <DashboardRecentItem :item="item" />
                </li>
            </ul>
        </div>

        <Loading :show="dashboardAccess.state.loadingRecentItems" loadingStyle="progress-bar" />
    </section>
</template>
